import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-scroll";

const Hero = () => {
  return (
    <section
      id="hero"
      className="relative bg-gray-900 text-white h-screen flex flex-col justify-center items-center overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden">
        <div className="absolute bg-blue-500 rounded-full blur-3xl opacity-20 w-72 h-72 top-10 left-10 animate-pulse-slow"></div>
        <div className="absolute bg-purple-600 rounded-full blur-3xl opacity-20 w-96 h-96 bottom-10 right-10 animate-pulse-slow"></div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-b from-transparent to-gray-900 z-20 pointer-events-none" />
      
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="text-center px-6 sm:px-10 md:px-20 z-10"
      >
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold mb-6 drop-shadow-glow leading-tight">
          Creating Digital Experiences That Deliver Impact
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl max-w-3xl mx-auto text-gray-300 mb-8">
          At <span className="text-cyan-400 font-semibold">SKYZM</span>, we build high-impact software solutions, stunning websites and scalable systems
          that transform your vision into measurable success. Whether you're a startup or enterprise — we deliver innovation, reliability and results.
        </p>
        <motion.div>
          <Link
            to="contact"
            smooth
            duration={1000}
            offset={-70} 
            className="inline-block px-8 py-4 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-lg text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
          >
            🚀 Start Your Project
          </Link>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;